/**
 * Stale-chunk recovery. After a deploy, chunks from the previous build no
 * longer exist on Cloudflare Pages — the SPA fallback serves index.html for
 * their URLs — so tabs opened before the deploy fail their next lazy
 * import. Reloading fetches the new build. The timestamp guard prevents a
 * reload loop when a failure has some other cause.
 */

const RELOAD_KEY = 'pulse-stale-chunk-reload';
const RELOAD_LOOP_WINDOW_MS = 30_000;

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /dynamically imported module|Importing a module script failed|Unable to preload CSS|Loading chunk/i.test(
    message
  );
}

/** Reload to pick up the new build; returns false if reloaded too recently. */
export function reloadOnceForNewBuild(): boolean {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
  } catch {
    // Storage unavailable (private mode) — still reload, just without the guard.
  }
  if (Date.now() - last < RELOAD_LOOP_WINDOW_MS) {
    return false;
  }
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // Ignore.
  }
  window.location.reload();
  return true;
}
